import(/* webpackMode: "eager" */ "/codebuild/output/src2907867774/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
